import React from 'react';
import { Check, ArrowRight, Sparkles, Clock, Gift } from 'lucide-react';
import { plansData, contactData } from '../../data/mock';
import { Button } from '../ui/button';

const PlansSection = () => {
  return (
    <section id="planos" className="py-20 bg-gradient-to-b from-stone-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-50 text-amber-700 text-sm font-medium rounded-full mb-4">
            Planos
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-4">
            {plansData.title}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {plansData.subtitle}
          </p>
        </div>

        {/* Plans Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
          {plansData.plans.map((plan) => (
            <div
              key={plan.id}
              className={`relative bg-white rounded-2xl overflow-hidden transition-all duration-300 ${
                plan.featured
                  ? 'border-2 border-amber-500 shadow-2xl shadow-amber-600/10 lg:scale-105 z-10'
                  : 'border border-stone-200 hover:border-amber-200 hover:shadow-xl'
              }`}
            >
              {/* Featured Badge */}
              {plan.featured && plan.badge && (
                <div className="absolute top-0 left-0 right-0">
                  <div className="bg-gradient-to-r from-amber-500 to-amber-600 text-white text-sm font-semibold py-2 px-4 text-center flex items-center justify-center gap-2">
                    <Sparkles className="w-4 h-4" />
                    {plan.badge}
                  </div>
                </div>
              )}

              <div className={`p-6 sm:p-8 ${plan.featured ? 'pt-14' : ''}`}>
                {/* Plan Name */}
                <h3 className="text-xl font-bold text-slate-800 mb-1">
                  {plan.name}
                </h3>
                <p className="text-sm text-slate-500 mb-4">{plan.tagline}</p>

                {/* Price */}
                <div className="mb-6">
                  <div className="flex items-baseline gap-1">
                    <span className="text-sm text-slate-500">R$</span>
                    <span className="text-4xl font-bold text-slate-800">
                      {plan.price.toLocaleString('pt-BR')}
                    </span>
                  </div>
                  <p className="text-sm text-slate-500 mt-1">
                    ou {plan.installments}x de R$ {plan.installmentValue.toLocaleString('pt-BR')} sem juros
                  </p>
                </div>

                {/* For Who */}
                <div className="bg-stone-50 rounded-xl p-4 mb-6">
                  <p className="text-sm text-slate-600">
                    <span className="font-semibold text-slate-700">Para quem é:</span>
                    <br />
                    {plan.forWho}
                  </p>
                </div>

                {/* Features */}
                <ul className="space-y-3 mb-6">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <div className="w-5 h-5 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <Check className="w-3 h-3 text-amber-600" />
                      </div>
                      <span className="text-sm text-slate-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* Bonus */}
                {plan.bonus && (
                  <div className="flex items-start gap-3 p-4 bg-amber-50 border border-amber-100 rounded-xl mb-6">
                    <Gift className="w-5 h-5 text-amber-600 flex-shrink-0" />
                    <span className="text-sm font-medium text-amber-800">
                      {plan.bonus}
                    </span>
                  </div>
                )}

                {/* Delivery */}
                <div className="flex items-center gap-2 text-sm text-slate-500 mb-6">
                  <Clock className="w-4 h-4" />
                  <span>Entrega em {plan.delivery}</span>
                </div>

                {/* CTA - ÚNICO PONTO DE CONTATO */}
                <a
                  href={contactData.getWhatsappUrl(plan.name)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button
                    className={`w-full py-6 text-base font-semibold transition-all group ${
                      plan.featured
                        ? 'bg-amber-600 hover:bg-amber-700 text-white shadow-lg shadow-amber-600/25 hover:shadow-amber-600/40'
                        : 'bg-slate-800 hover:bg-slate-900 text-white'
                    }`}
                  >
                    Quero Este Plano
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Payment Info */}
        <div className="mt-12 text-center">
          <p className="text-slate-500 text-sm">
            Pagamento: à vista (PIX ou boleto) ou parcelado em até 3x sem juros no cartão
          </p>
        </div>
      </div>
    </section>
  );
};

export default PlansSection;
